import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

interface GetParams {
  ids: string[];
}

export default class MediaObjectsApi extends Api {
  readonly url = "/v3/media_objects/";

  constructor($axios: Context["$axios"]) {
    super("postService", $axios);
  }

  async get({ ids }: GetParams) {
    return await this.request<ManyMediaObjectsResponse>({
      method: "GET",
      params: {
        ids,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 10 })
  async getOne(...ids: string[]) {
    return await this.get({ ids });
  }
}
